export default {"src":"/_next/static/media/manaub.c51ab056.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};